import React from "react";
import { fmtMoney } from "@/lib/api";

const Metric = ({ label, value, note, id, tone = "" }) => (
  <div className={`min-w-0 p-3 sm:p-4 ${tone}`} data-testid={`${id}-box`}>
    <div className="text-xs font-medium text-muted-foreground" data-testid={`${id}-label`}>{label}</div>
    <div className="mono-num mt-1 break-words text-xl font-bold [overflow-wrap:anywhere]" data-testid={id}>{fmtMoney(value)}</div>
    <div className="mt-1 text-xs text-muted-foreground [overflow-wrap:anywhere]" data-testid={`${id}-note`}>{note}</div>
  </div>
);

export const ColonyStatementTotals = ({ statement, prefix = "colony-stat", overhead = false }) => {
  const balance = Number(statement.balance || 0);
  return <section className="min-w-0 space-y-3" data-testid={`${prefix}-summary`}>
    <div className="grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-border bg-border sm:grid-cols-3">
      <Metric id={`${prefix}-billed`} label={overhead ? "Overhead" : "Billed"} value={statement.billed_total} note={overhead ? "Not assigned to a colony" : statement.period_year ? `Sent invoices dated ${statement.period_year}` : "Sent invoices only"} tone="bg-background" />
      <Metric id={`${prefix}-received`} label="Received" value={statement.received_total} note={statement.period_year ? `Payments dated ${statement.period_year}` : "Payments received"} tone="bg-emerald-50 text-emerald-800" />
      <Metric id={`${prefix}-balance`} label="Billed balance" value={statement.balance} note={balance < 0 ? "Credit on account" : "Billed minus payments"} tone="bg-rose-50 text-rose-800" />
    </div>
    {!overhead && <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div className="min-w-0 rounded-sm border border-amber-200 bg-amber-50/60">
        <Metric id={`${prefix}-unbilled`} label="Not yet billed" value={statement.unbilled_total} note={`Includes drafts · ${fmtMoney(statement.draft_invoices_total)} in unsent invoices`} />
      </div>
      <div className="min-w-0 rounded-sm border border-sky-200 bg-sky-50/60">
        <Metric id={`${prefix}-total-owed`} label="Total owed" value={statement.total_owed} note="Includes amounts not yet billed · after payments" />
      </div>
    </div>}
  </section>;
};

export const ChargeBillingBadge = ({ status, id }) => <span
  className={`ml-2 shrink-0 rounded-sm px-1.5 py-0.5 text-[10px] font-semibold ${status === "billed" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-900"}`}
  data-testid={id}
>{status === "billed" ? "Billed" : status === "draft" ? "Draft · not billed" : "Not yet billed"}</span>;